<script lang="ts">
	import {route} from './helpers/router';
</script>

<main>
	<svelte:component this={route()}/>
</main>

